import { render, staticRenderFns } from "./CreatedInOldAccountChip.vue?vue&type=template&id=7b095739&scoped=true"
import script from "./CreatedInOldAccountChip.vue?vue&type=script&lang=js"
export * from "./CreatedInOldAccountChip.vue?vue&type=script&lang=js"
import style0 from "./CreatedInOldAccountChip.vue?vue&type=style&index=0&id=7b095739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b095739",
  null
  
)

export default component.exports